export default "__VITE_ASSET__DlpsZ0vF__"